export const login = (social, permissions, cb, promotion) => {
	const accepted_nets = ['google', 'linkedin', 'twitch', 'facebook', 'madrid', 'tiktok'];
	if(!accepted_nets.includes(social)) return;

	const promo = (promotion != undefined) ? `?pid=${promotion}` : '';

	let url_login = `/utils/social/${social}${promo}`
	const new_url_login = ['google','tiktok','linkedin','twitch','facebook'];	
	if(new_url_login.includes(social) && (promotion > 973371 || window?.is_local))url_login = `/social_login/${social}${promo}`
	$.get(url_login, (resp) => {
		if(resp.status == 0) {
			if(resp.error)window.location.reload()
			if(resp.url)window.location.href = resp.url;
		} else {
			if(cb != undefined) cb({ customResponse:resp });
		}
	}, 'JSON');
};

const checkFB = (cb) => {
	fbEnsureUserStatus(() => {
		FB.api(`/me?fields=id,name,first_name,last_name,email,verified,birthday,gender`, (response) => {
			if(cb) { cb(response); }
		});
	});
};